import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import PhoneInTalkRoundedIcon from '@mui/icons-material/PhoneInTalkRounded';
import GraphicEqRoundedIcon from '@mui/icons-material/GraphicEqRounded';
import SettingsEthernetRoundedIcon from '@mui/icons-material/SettingsEthernetRounded';

export const CHANNEL_TYPE_ORDER = ['WEB', 'VAPI', 'REALTIME'];

export const ALL_CHANNEL_TYPES = [
  {
    value: 'WEB',
    label: 'Web Channel',
    description: 'Configure the embedded chat widget and web-specific behavior.',
    tone: 'web',
    icon: LanguageRoundedIcon,
  },
  {
    value: 'VAPI',
    label: 'Phone Channel',
    description: 'Manage voice calls, greetings, and phone delivery settings.',
    tone: 'phone',
    icon: PhoneInTalkRoundedIcon,
  },
  {
    value: 'REALTIME',
    label: 'Realtime Voice',
    description: 'Tune low-latency voice conversations and live audio settings.',
    tone: 'realtime',
    icon: GraphicEqRoundedIcon,
  },
];

const FALLBACK_META = {
  label: 'Channel',
  description: 'Manage channel-specific delivery and behavior settings.',
  tone: 'default',
  icon: SettingsEthernetRoundedIcon,
};

export const normalizeChannelKey = (value) => {
  const key = String(value || '').trim().toUpperCase();

  if (key === 'PHONE') return 'VAPI';
  if (key === 'REALTIME VOICE' || key === 'REALTIME_VOICE' || key === 'VOICE') return 'REALTIME';

  return key;
};

export const getChannelMeta = (value) => {
  const normalizedValue = normalizeChannelKey(value);
  const found = ALL_CHANNEL_TYPES.find((channel) => channel.value === normalizedValue);

  if (found) return found;

  return {
    ...FALLBACK_META,
    label: normalizedValue || FALLBACK_META.label,
  };
};
